import titleInlineEditor from './titleInlineEditor';
import descriptionInlineEditor from './descriptionInlineEditor';

const handleOnKeyDown = (event) => {
  if (event.keyCode === 13) {
    event.preventDefault();
  }
};

const createInlineEditor = (id, tag, text, options, onKeyDown) => ({
  id,
  tag,
  text,
  options,
  onKeyDown,
});

export default ({ videoCompose, videoVersion }) => {
  const {
    data: { name, description },
  } = videoCompose;

  return {
    name: {
      type: 'InlineEditors',
      options: {
        editors: [
          createInlineEditor(1, 'h1', name, titleInlineEditor({ videoVersion }), handleOnKeyDown),
        ],
      },
    },
    description: {
      type: 'InlineEditors',
      options: {
        editors: [
          createInlineEditor(2, 'p', description, descriptionInlineEditor({ videoVersion })),
        ],
      },
    },
  };
};
